// solution org names same as in DB
export const JOIST_DOMAIN = 'joist';
export const SERVICE_FUSION_DOMAIN = 'service fusion';
export const INVOICE_SIMPLE_DOMAIN = 'invoice simple';
export const ROOFSNAP_DOMAIN = 'roofsnap';
export const KICKSERV_DOMAIN = 'kickserv';
export const MARKETSHARP_DOMAIN = 'marketsharp';
export const IMPROVE_IT_360_DOMAIN = 'improve it 360';
export const EVERPRO_EDGE_PUBLIC_DOMAIN = 'everpro edge public'; // solution org for public registration users
export const SERVICE_NATION_DOMAIN = 'service nation';
export const EVERPRO_DOMAIN = [
  INVOICE_SIMPLE_DOMAIN,
  ROOFSNAP_DOMAIN,
  KICKSERV_DOMAIN,
  MARKETSHARP_DOMAIN,
  IMPROVE_IT_360_DOMAIN,
  EVERPRO_EDGE_PUBLIC_DOMAIN,
];
export const SERVICE_NATION_NAME = 'Service Nation';
export const EVERPRO_NAME = 'EverPro';
export const EDGE_ENROLL_ATTEMPTS_METRIC_NAME = 'EdgeEnrollmentAttempts';
export const EDGE_ENROLL_SUCCESS_METRIC_NAME = 'EdgeEnrollmentSuccesses';
export const HD_MOBILE_ENROLL_ATTEMPTS_METRIC_NAME = 'HdMobileEnrollmentAttempts';
export const HD_IOS_ENROLL_ATTEMPTS_METRIC_NAME = 'HdIOSEnrollmentAttempts';
export const HD_ANDROID_ENROLL_ATTEMPTS_METRIC_NAME = 'HdAndroidEnrollmentAttempts';
export const HD_MOBILE_ENROLL_SUCCESS_METRIC_NAME = 'HdMobileEnrollmentSuccesses';
export const HD_IOS_ENROLL_SUCCESS_METRIC_NAME = 'HdIOSEnrollmentSuccesses';
export const HD_ANDROID_ENROLL_SUCCESS_METRIC_NAME = 'HdAndroidEnrollmentSuccesses';
export const CUSTOM_ONBOARDING_METRICS_NAMESPACE = 'CustomOnboardingMetrics';

export const WEB = 'web';
export const IOS = 'ios';
export const AOS = 'android';

// Partner names
export const HOME_DEPOT_NAME = 'HomeDepot';
export const LENNOX_NAME = 'Lennox';
export const HD_SUPPLY_NAME = 'HD Supply';
export const CAPITAL_WRAPS_NAME = 'Capital Wraps';
export const SPARTAN_TOOL_NAME = 'Spartan Tool';
export const WINSUPPLY_NAME = 'Winsupply';
export const WESUPPLYTRADES_NAME = 'WeSupplyTrades';
export const COAST_NAME = 'Coast';
export const SUNBELT_RENTALS_NAME = 'Sunbelt Rentals';
export const EVERCONNECT_NAME = 'EverConnect';
export const RINNAI_NAME = 'Rinnai';
export const POSTCARDMANIA_NAME = 'PostcardMania';
export const BEHR_NAME = 'Behr';
export const BAYTEK_NAME = 'Baytek';
export const GUSTO_NAME = 'Gusto';
export const HDX_NAME = 'HDX';
export const NOVO_NAME = 'NOVO Professional Water Systems';

// Partner codes
export const HOME_DEPOT_CODE = 'hd';
export const LENNOX_CODE = 'LN';
export const HD_SUPPLY_CODE = 'HDS';
export const CAPITAL_WRAPS_CODE = 'CW';
export const SPARTAN_TOOL_CODE = 'ST';
export const WINSUPPLY_CODE = 'WS';
export const WESUPPLYTRADES_CODE = 'WST';
export const COAST_CODE = 'CO';
export const SUNBELT_RENTALS_CODE = 'SBR';
export const EVERCONNECT_CODE = 'EV';
export const RINNAI_CODE = 'RI';
export const POSTCARDMANIA_CODE = 'PO';
export const BEHR_CODE = 'BR';
export const BAYTEK_CODE = 'BA';
export const GUSTO_CODE = 'GU';
export const HDX_CODE = 'HDX';
export const NOVO_CODE = 'NO';
// Some partners have one row per membership tier (edge / association / srt),
// each with its own code because of a UNIQUE(code) constraint. A non-edge row's
// code is the edge code plus that tier's suffix (e.g. HD Supply: edge 'HDS',
// association 'HDS-AM', srt 'HDS-SRT').
// TODO: remove once partners are consolidated to one row per partner and the
// partner config moves to the DB (future ticket). The cumulative tier logic
// makes the duplicate rows unnecessary: a partner shared by several tiers is
// attached to the lowest tier that may see it (SN-996).
export const PARTNER_SRT_CODE_SUFFIX = '-SRT';
export const PARTNER_AM_CODE_SUFFIX = '-AM';

// Every tier suffix a partner code can carry, longest first so that stripping
// tries '-SRT' before any suffix that is a tail of another.
export const PARTNER_TIER_CODE_SUFFIXES = [
  PARTNER_SRT_CODE_SUFFIX,
  PARTNER_AM_CODE_SUFFIX,
];

// getBasePartnerCode lives in ./getBasePartnerCode.ts (not here): this file is
// imported by the FE as raw TS source and parsed as plain JS by CRA's webpack,
// so it must stay free of TS-only syntax (e.g. typed function signatures).

// External-enrollment-form partners (manufacturers / SSO redirects)
export const THE_HOME_DEPOT_CODE = 'hd';
export const RHEEM_CODE = 'RM';
export const RUUD_CODE = 'RU';
export const LENNOX_RESIDENTIAL_CODE = 'LR';
export const LENNOX_COMMERCIAL_CODE = 'LC';
export const GOODMAN_DAIKIN_AMANA_CODE = 'GDA';

// list of partners (by code) having vehicle question during enrollment
export const partnersRequireVehicleQuestion = [
  CAPITAL_WRAPS_CODE,
  HD_SUPPLY_CODE,
  COAST_CODE,
];

// event names
export const HD_SUPPLY_SIGN_UP_FORM_SUBMITTED_EVENT_NAME = 'Partner-Enrollment-Submit-HdSupplySignupForm';
export const HD_SUPPLY_ENROLLED_EVENT_NAME = 'Partner-Enrollment-Submit-HdSupplyAccountNumberForm';
export const CAPITAL_WRAPS_ENROLLED_EVENT_NAME = 'Partner-Enrollment-Submit-CapitalWrapsSignupForm';
export const SPARTAN_TOOL_ENROLLED_EVENT_NAME = 'Partner-Enrollment-Submit-SpartanToolSignupForm';
export const WINSUPPLY_SIGN_UP_FORM_SUBMITTED_EVENT_NAME = 'Partner-Enrollment-Submit-WinsupplySignupForm';
export const WINSUPPLY_ACCOUNT_NUMBER_SUBMITTED_EVENT_NAME = 'Partner-Enrollment-Submit-WinsupplyAccountNumberForm';
export const WESUPPLYTRADES_ACCOUNT_NUMBER_SUBMITTED_EVENT_NAME = 'Partner-Enrollment-Submit-WeSupplyTradesSignupForm';
export const COAST_SIGN_UP_FORM_SUBMITTED_EVENT_NAME = 'Partner-Enrollment-Submit-CoastSignupForm';
export const SUNBELT_RENTALS_SIGN_UP_FORM_SUBMITTED_EVENT_NAME = 'Partner-Enrollment-Submit-SunbeltRentalsSignupForm';
export const SUNBELT_RENTALS_ACCOUNT_NUMBER_SUBMITTED_EVENT_NAME = 'Partner-Enrollment-Submit-SunbeltRentalsAccountNumberForm';
export const EVERCONNECT_SIGN_UP_FORM_SUBMITTED_EVENT_NAME = 'Partner-Enrollment-Submit-EverConnectSignupForm';
export const RINNAI_SIGN_UP_FORM_SUBMITTED_EVENT_NAME = 'Partner-Enrollment-Submit-RinnaiSignupForm';
export const POSTCARDMANIA_SIGN_UP_FORM_SUBMITTED_EVENT_NAME = 'Partner-Enrollment-Submit-PostcardManiaSignupForm';
export const BEHR_SIGN_UP_FORM_SUBMITTED_EVENT_NAME = 'Partner-Enrollment-Submit-BehrSignupForm';
export const BAYTEK_SIGN_UP_FORM_SUBMITTED_EVENT_NAME = 'Partner-Enrollment-Submit-BaytekSignupForm';
export const GUSTO_SIGN_UP_FORM_SUBMITTED_EVENT_NAME = 'Partner-Enrollment-Submit-GustoSignupForm';
export const HDX_SIGN_UP_FORM_SUBMITTED_EVENT_NAME = 'Partner-Enrollment-Submit-HdxSignupForm';
export const NOVO_SIGN_UP_FORM_SUBMITTED_EVENT_NAME = 'Partner-Enrollment-Submit-NovoProfessionalWaterSystemsSignupForm';

// Wallet Min Payment Amount based on Wallet Config
export const WALLET_MIN_PAYMENT_AMOUNT = 5;

// Fallback Image URL
export const FALLBACK_IMAGE_URL = 'https://d2o7bp9oz3gksv.cloudfront.net/content_fallback_image_82faef26e1.png';
